module.exports = __webpack_public_path__ + "static/media/ApplyForBoth-Icon.78d2bf36.svg";